import { datadogLogs } from "@datadog/browser-logs";
import awsconfig from "../aws-exports";

export const initializeDatadogLogging = (isProduction = false, clientToken) => {
    if (isProduction && clientToken) {
        datadogLogs.init({
            clientToken: clientToken,
            site: 'datadoghq.com',
            service: "isp-ui",
            env: "prod",
            forwardErrorsToLogs: true,
            sessionSampleRate: 100,
            injectLogContext: true,
        });
    }
};


export const logMessage = (message, level = 'info', context = {}) => {
    if (datadogLogs.logger && awsconfig.isProduction) {
        datadogLogs.logger[level](message, context);
    } else {
        console.log(message, context);
    }
};
